'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState } from 'react';
import Toast from '../Toast/index.js';
import ReportCompanyDialog, { openReportDialog } from './ReportCompanyDialog.js';
import ReportCompanySuccessDialog, { openReportSuccessDialog } from './ReportSuccessDialog.js';
import { ReportCompanyModalContext } from './hooks.js';
import Button from '../Button/index.js';
import translations from './translation.js';
import { LOGIN_POPUP } from '../LoginModal/constants.js';
import ReportIcon from '../Images/ReportIcon/index.js';
import SimpleTooltip from '../SimpleTooltip/index.js';

var ReportCompanyModal = function (props) {
    var _a = useState(false), isReportSuccess = _a[0], setIsReportSuccess = _a[1];
    var _b = useState(false); _b[0]; _b[1];
    var _c = props.data, data = _c === void 0 ? {
        company: {
            companyId: 0,
            companyLogo: '',
            companyName: ''
        },
        apiTokenAccess: '',
        isAuthenticated: 0,
        apiGetway: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0',
        isReportCompany: false,
        imagesService: 'https://staging-images.vietnamworks.com/images',
        faqService: '',
        redirectPage: '',
        wnwBaseURL: ''
    } : _c, _d = props.language, language = _d === void 0 ? 'vi' : _d, _e = props.useGlobalToast, useGlobalToast = _e === void 0 ? false : _e, _f = props.locationClassName, locationClassName = _f === void 0 ? '' : _f;
    var _g = data || {}, isAuthenticated = _g.isAuthenticated, isReportCompany = _g.isReportCompany;
    var t = function (text) {
        if (language === 'vi') {
            return translations[text];
        }
        return text;
    };
    var handleReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isSuccess;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, openReportDialog(locationClassName)];
                case 1:
                    isSuccess = _a.sent();
                    if (!isSuccess) return [3 /*break*/, 3];
                    return [4 /*yield*/, openReportSuccessDialog(locationClassName)];
                case 2:
                    _a.sent();
                    setIsReportSuccess(true);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClickReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loginEvent;
        return __generator(this, function (_a) {
            if (!isAuthenticated) {
                loginEvent = new CustomEvent(LOGIN_POPUP, {
                    detail: {
                        langCode: language,
                        isNeedReload: true
                    }
                });
                window.dispatchEvent(loginEvent);
                return [2 /*return*/];
            }
            handleReport();
            return [2 /*return*/];
        });
    }); };
    var isReportedCompany = isReportCompany || isReportSuccess;
    var isMobile = typeof window !== "undefined" ? window.innerWidth < 480 : false;
    return (React__default.createElement(ReportCompanyModalContext.Provider, { value: {
            data: data,
            language: language,
            useGlobalToast: useGlobalToast,
            locationClassName: locationClassName,
            t: t
        } },
        React__default.createElement(React__default.Fragment, null,
            !useGlobalToast && React__default.createElement(Toast, null),
            React__default.createElement(ReportCompanyDialog, null),
            React__default.createElement(ReportCompanySuccessDialog, null),
            !isReportedCompany &&
                React__default.createElement(Button, { type: 'default', outline: "solid", onClick: handleClickReport, style: { padding: '8px 8px', 'maxWidth': '44px', width: '44px', margin: '0 8px', height: '42px' } },
                    React__default.createElement(ReportIcon, { color: '#888' })),
            isReportedCompany &&
                React__default.createElement(SimpleTooltip, { isMobile: isMobile, content: isMobile ? t('VietnamWorks has received the report. VietnamWorks is checking and working with the company. And we will reply to you as soon as possible.') : t('Reported this company'), title: t('Reported this company'), align: 'end', referenceElement: React__default.createElement(Button, { type: 'default', outline: "solid", disabled: true, style: { padding: '8px 8px', 'maxWidth': '44px', width: '44px', margin: '0 8px', height: '42px' } },
                        React__default.createElement(ReportIcon, { color: '#C9C9C9' })) }))));
};

export { ReportCompanyModal as default };
//# sourceMappingURL=index.js.map
